<div class="d-flex justify-content-center">
  <div class="col-12">
    @if (job()) {
      <div>
        <h2 data-cy="jobDetailsHeading"><span jhiTranslate="recruitmentApp.job.detail.title">Job</span></h2>

        <hr />

        <jhi-alert-error></jhi-alert-error>

        <jhi-alert></jhi-alert>

        <dl class="row-md jh-entity-details">
          <dt><span jhiTranslate="recruitmentApp.job.image">Image</span></dt>
          <dd>
            @if (job()!.image) {
              <img
                [src]="'data:' + job()!.imageContentType + ';base64,' + job()!.image"
                alt="job"
                class="img-fluid img-thumbnail"
                style="max-width: 400px"
              />
            }
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.title">Title</span></dt>
          <dd>
            <h4>{{ job()!.title }}</h4>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.shortDescription">Short Description</span></dt>
          <dd>
            <span>{{ job()!.shortDescription }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.description">Description</span></dt>
          <dd [innerHTML]="job()!.description"></dd>
          <dt><span jhiTranslate="recruitmentApp.job.eduQualify">Edu Qualify</span></dt>
          <dd>
            <span [jhiTranslate]="'recruitmentApp.education.' + (job()!.eduQualify ?? 'null')">
              {{ [job()!.eduQualify ?? 'null'] }}
            </span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.eduQualifyMax">Edu Qualify Max</span></dt>
          <dd>
            <span [jhiTranslate]="'recruitmentApp.education.' + (job()!.eduQualifyMax ?? 'null')">
              {{ [job()!.eduQualifyMax ?? 'null'] }}
            </span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.experienceYear">Experience Year</span></dt>
          <dd>
            <span>{{ job()!.experienceYear }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.salaryMin">Salary Min</span></dt>
          <dd>
            <span>{{ job()!.salaryMin }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.salaryLimit">Salary Limit</span></dt>
          <dd>
            <span>{{ job()!.salaryLimit }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.industry">Industry</span></dt>
          <dd>
            @for (industry of job()!.industries; track $index; let last = $last) {
              <span>
                <a [routerLink]="['/industry', industry.id, 'view']">{{ industry?.name }}</a
                >{{ last ? '' : ', ' }}
              </span>
            }
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.citizenship">Citizenship</span></dt>
          <dd>
            <span [jhiTranslate]="'recruitmentApp.citizenship.' + (job()!.citizenship ?? 'null')">{{
              { null: '', NATIONAL: 'NATIONAL', FOREIGN: 'FOREIGN' }[job()!.citizenship ?? 'null']
            }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.status">Status</span></dt>
          <dd>
            <span [jhiTranslate]="'recruitmentApp.JobStatus.' + (job()!.status ?? 'null')">{{
              { null: '', DRAFT: 'DRAFT', PUBLISHED: 'PUBLISHED', INACTIVE: 'INACTIVE' }[job()!.status ?? 'null']
            }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.createdDate">Created Date</span></dt>
          <dd>
            <span>{{ job()!.createdDate | formatMediumDatetime }}</span>
          </dd>
          <dt><span jhiTranslate="recruitmentApp.job.expireDate">Expired Date</span></dt>
          <dd>
            <span>{{ job()!.expireDate | formatMediumDatetime }}</span>
          </dd>

          <dt></dt>
          <dd class="pt-3" style="border-bottom: none">
            <button type="submit" (click)="previousState()" class="btn btn-info" data-cy="entityDetailsBackButton">
              <fa-icon icon="arrow-left"></fa-icon>&nbsp;<span jhiTranslate="entity.action.back">Back</span>
            </button>

            <button type="button" [routerLink]="['/job', job()!.id, 'edit']" class="btn btn-primary">
              <fa-icon icon="pencil-alt"></fa-icon>&nbsp;<span jhiTranslate="entity.action.edit">Edit</span>
            </button>
          </dd>
        </dl>
      </div>
    }
  </div>
</div>
